<template>
  <div class="c-timeline">
    <div class="c-timeline__top">
      <el-tooltip
        :open-delay="500"
        effect="dark"
        content="На шаг назад"
        placement="top"
      >
        <el-button
          class="r-button icon-button c-timeline__controls-btn previous"
          circle
          size="mini"
          @click="goToStep('previous')"
          type="primary"
          :disabled="current === 0"
        >
          <r-icon name="chevron-left" :size="24" />
        </el-button>
      </el-tooltip>
      <div class="c-timeline__current">
        <r-title type="title-1" style>
          {{ formatTooltip(current) }}
        </r-title>
      </div>
      <el-tooltip
        :open-delay="500"
        effect="dark"
        content="На шаг вперед"
        placement="top"
      >
        <el-button
          class="r-button icon-button c-timeline__controls-btn previous"
          circle
          size="mini"
          @click="goToStep('next')"
          type="primary"
          :disabled="current === times.length - 1"
        >
          <r-icon name="chevron-right" :size="24" />
        </el-button>
      </el-tooltip>
    </div>
    <div class="c-timeline__bottom">
      <div class="c-timeline__left">
        <el-tooltip
          :open-delay="500"
          effect="dark"
          :content="timemachinePlaying ? 'Остановить' : 'Запустить'"
          placement="top"
        >
          <el-button
            class="r-button icon-button c-timeline__controls-btn play"
            circle
            size="mini"
            @click="playClickHandler"
            type="primary"
          >
            <r-icon :name="timemachinePlaying ? 'pause' : 'play'" :size="24" />
          </el-button>
        </el-tooltip>
      </div>
      <div class="c-timeline__center">
        <div class="c-timeline__slider">
          <el-slider
            class="r-slider dark square"
            :min="0"
            :max="times.length - 1"
            :step="1"
            v-model="current"
            @change="changeTimeValue"
            :show-tooltip="false"
            :format-tooltip="formatTooltip"
          />
        </div>
        <div class="c-timeline__time-labels">
          <r-text type="caption" style="margin-bottom: 0; margin-right: 16px;">
            {{ formatTooltip(0) }}
          </r-text>
          <r-text type="caption" style="margin-bottom: 0; margin-left: 16px;">
            {{ formatTooltip(times.length - 1) }}
          </r-text>
        </div>
      </div>
      <div class="c-timeline__right">
        <el-tooltip
          :open-delay="500"
          effect="dark"
          content="Запустить с начала"
          placement="top"
        >
          <el-button
            class="r-button icon-button c-timeline__controls-btn refresh"
            circle
            size="mini"
            @click="refreshPlaying"
            type="primary"
          >
            <r-icon name="replay" :size="24" />
          </el-button>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { secondsToTime } from "@/utils";

export default {
  data() {
    return {
      current: 0,
      interval: null,
      playingStep: 20
    };
  },
  computed: {
    times() {
      return this.$store.state.calculations.times;
    },
    timemachinePlaying() {
      return this.$store.state.calculations.playing;
    }
  },
  methods: {
    formatTooltip(value) {
      const { h, m, s } = secondsToTime(this.times[value]);

      return `${h}:${m}:${s}`;
    },
    changeTimeValue(index) {
      this.$store.commit("SET_CALC_FIELD", {
        field: "currentTime",
        value: this.times[index]
      });
    },
    playClickHandler() {
      if (this.timemachinePlaying) this.stop();
      else this.play();
    },
    play() {
      this.$store.commit("SET_CALC_FIELD", {
        field: "playing",
        value: true
      });

      this.interval = setInterval(() => {
        const nextStep = this.current + this.playingStep;

        if (nextStep <= this.times.length - 1) {
          this.current += this.playingStep;
        } else {
          this.current = this.times.length - 1;
          this.stop();
        }

        this.changeTimeValue(this.current);
        this.$forceUpdate();
      }, 300);
    },
    refreshPlaying() {
      this.current = 0;

      if (this.timemachinePlaying) this.stop();
      this.changeTimeValue(this.current);
      this.play();
    },
    stop() {
      clearInterval(this.interval);
      this.$store.commit("SET_CALC_FIELD", {
        field: "playing",
        value: false
      });
      this.interval = null;
    },
    goToStep(type) {
      switch (type) {
        case "next": {
          const nextStep = this.current + 1;

          if (nextStep <= this.times.length - 1) {
            this.current += 1;
          } else {
            this.current = this.times.length - 1;
          }
          break;
        }
        case "previous": {
          const previousStep = this.current - 1;

          if (previousStep <= this.times.length - 1) {
            this.current -= 1;
          } else {
            this.current = this.times.length - 1;
          }
        }
      }

      this.changeTimeValue(this.current);
    }
  },
  created() {
    const { currentTime } = this.$store.state.calculations;

    this.current = this.times.findIndex(t => t === currentTime);
  }
};
</script>

<style lang="scss">
.c-timeline {
  position: absolute;
  right: 16px;
  bottom: 32px;
  padding: 16px;
  z-index: 10;
  border-radius: 4px;
  border: 1px solid transparent;
  background-color: var(--bg_panel_secondary) !important;
  border-color: var(--dividers_low_contrast) !important;
  color: var(--text_secondary) !important;
  width: 50vh;

  &__top {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__current {
    padding: 4px 12px;
    border-radius: 4px;
    margin: 0 16px;
    background-color: var(--field_bg) !important;

    .r-title {
      font-size: 16px;
      font-weight: bold;
      letter-spacing: 2px;
    }
  }

  &__bottom {
    display: flex;
    margin-top: 8px;
  }

  &__center {
    flex: 1;
    margin: 0 16px;
  }

  &__controls-btn.r-button.icon-button.is-circle {
    padding: 4px !important;
  }

  &__time-labels {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__slider {
    display: flex;

    .r-slider {
      flex: 1;

      .el-slider {
        &__runway {
          height: 16px !important;
          margin: 8px !important;
        }

        &__bar {
          height: 16px !important;
          background-color: rgba(var(--accent_primary), 0.3) !important;
        }

        &__button {
          height: 16px !important;
          width: 8px !important;
          border-radius: 2px !important;

          &-wrapper {
            top: -10px !important;
          }
        }
      }
    }
  }
}
</style>
